export default __webpack_public_path__ + "static/media/flag-zh-TW.47962f96.png";